import {
  isConnectionUpdatedAction,
  isConversationMessageAction,
  isConversationReadAction,
} from 'ha/modules/RealtimeMessaging/utils';

import { loadInbox } from '../actions';
import { getDisplayParams, getInitial } from '../reducer';

export default ({ dispatch, getState }) => next => action => {
  next(action);

  const state = getState();

  const isInitialState = getInitial(state);

  if (isInitialState === undefined) return;

  if (
    isConversationMessageAction(action) ||
    isConversationReadAction(action) ||
    isConnectionUpdatedAction(action)
  ) {
    const params = getDisplayParams(state);

    dispatch(loadInbox(params));
  }
};
